import Button from '@/components/Button';
import Field from '@/components/Field';
import TextInput from '@/components/TextInput';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useInquiryAppointment } from './useInquiryAppointment';
import classes from './virtualAppointments.module.css';

export const InquiryAppointment = props => {
  const inqueryModulTitle = 'INQUIRY APPOINTMENT';
  const router = useRouter();

  const afterSubmit = useCallback(
    (email, phone) => {
      // 跳转到预约单列表页
      router.push(`/appointmentlist?email=${email}&phone=${phone}`);
    },
    [router],
  );

  const talonProps = useInquiryAppointment({
    afterSubmit,
  });

  const { handleSubmit } = talonProps;

  return (
    <div className={classes.inquiryappointment}>
      <h1 className={classes.inquiryappointmenttitle}>{inqueryModulTitle}</h1>
      <Form
        className={classes.queryform}
        onSubmit={handleSubmit}
      >
        <Field
          id='email'
          label={<span className='text-[15px]'>Email</span>}
          required
        >
          <TextInput
            autoComplete='email'
            field='email'
            id='Email'
            validate={isRequired}
          />
        </Field>
        <Field
          id='phone'
          label={<span className='text-[15px]'>Phone</span>}
          required
        >
          <TextInput
            autoComplete='phone'
            field='phone'
            id='Phone'
            validate={isRequired}
          />
        </Field>
        <div>
          <Button
            type='submit'
            className={classes.submitButton}
          >
            CHECK
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default InquiryAppointment;
